import { useApi } from '@/api';
import { EntityName, Page, PageSkeleton } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, Flex, Heading } from '@blockanalitica/ui';
import EventsTable from './EventsTable';
import HistoricGraph from './HistoricGraph';

export default function StakingEngineStabilityFeePage() {
  const ilk = 'LSEV2-SKY-A';
  const [data, error] = useApi({
    url: `/groups/staked/ilks/${ilk}/parameters/stability-fee/`,
    queryParams: {
      days_ago: 1
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <Flex gap="3xs" alignItems="center">
            <EntityName
              symbol1={
                <CryptoIcon
                  name={tokensMapping('SKY').name}
                  address={tokensMapping('SKY').address}
                  size="5"
                />
              }>
              <Flex gap="m" flexDirection="column">
                <Flex gap="3xs">
                  <Heading size="1">{data.name} Stability Fee</Heading>
                </Flex>
              </Flex>
            </EntityName>
          </Flex>
        }>
        <>
          <HistoricGraph ilk={ilk} />
          <EventsTable ilk={ilk} />
        </>
      </Page>
    );
  }

  return <PageSkeleton />;
}
